import { Box, Flex, Stack, Text } from '@chakra-ui/react';
import { Fragment } from 'react';

export function ChatBubble({
  body,
  time,
  displayName,
  isCurrentUser = false,
  isLastInGroup = false,
  onClick,
}: {
  body: string;
  time?: string;
  displayName?: string;
  isCurrentUser?: boolean;
  isLastInGroup?: boolean;
  onClick?: () => void;
}) {
  if (isCurrentUser) {
    return (
      <Stack alignItems="flex-end" w="full">
        <Box
          display="flex"
          py="1"
          px="3"
          flexDirection="column"
          justifyContent="center"
          alignItems="flex-start"
          borderTopLeftRadius="2xl"
          borderTopRightRadius="2xl"
          borderBottomLeftRadius="2xl"
          borderBottomRightRadius="none"
          color={'fg.inverse'}
          maxWidth="80%"
          bg={'bg.accent.default'}
          overflowWrap="break-word"
          wordBreak="break-word"
          onClick={onClick}
          cursor={onClick ? 'pointer' : 'default'}
        >
          <BubbleContents body={body} time={time} currentUser={true} />
        </Box>
      </Stack>
    );
  }

  return (
    <Stack alignItems="flex-start" w="full" mb={isLastInGroup ? '1' : '0'}>
      {displayName ? (
        <Text fontSize="xs" color="fg.subtle" ml="5">
          {displayName}
        </Text>
      ) : null}
      <Box
        display="flex"
        py="2"
        px="3"
        flexDirection="column"
        justifyContent="center"
        alignItems="flex-end"
        borderTopLeftRadius="2xl"
        borderTopRightRadius="2xl"
        borderBottomLeftRadius="none"
        borderBottomRightRadius="2xl"
        maxWidth="80%"
        bg="bg.muted"
        overflowWrap="break-word"
        wordBreak="break-word"
        onClick={onClick}
        cursor={onClick ? 'pointer' : 'default'}
      >
        <BubbleContents body={body} time={time} />
      </Box>
    </Stack>
  );
}

export function BubbleContents({
  body,
  time,
  currentUser,
}: {
  body: string;
  time?: string;
  currentUser?: boolean;
}) {
  const lines = body.split('\n');

  return (
    <Flex flexDirection="column" alignItems="flex-start" width="100%">
      <Text fontSize="sm" overflowWrap="break-word" wordBreak="break-word" flex="1">
        {lines.map((line) => (
          <Fragment key={line}>
            {line}
            <br />
          </Fragment>
        ))}
      </Text>
      {time ? (
        <Text
          fontSize="xs"
          color={currentUser ? 'fg.inverse-subtle' : 'fg.subtle'}
          mt="0.5"
          alignSelf="flex-end"
        >
          {time}
        </Text>
      ) : null}
    </Flex>
  );
}
